import type { DamageType } from "../damageType";
import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { Sound } from "./sounds/sound";
import { SoundId } from "./sounds/soundId";

export class CaveRock extends DestroyableObstacle {
	static key = "CaveRock";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.ROCK_DEBRIS;
	}

	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		this.board!.addNonPhysicalThing(new Sound(SoundId.ROCK_BREAK, this.xy));
		super.onZeroHp(source, type);
	}

	static deserialize(data: any): CaveRock {
		const c = new CaveRock(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
